import React from "react";
import { getFullName, getAddress } from "../../components/util/helpers";
import { useIntl } from "react-intl";
import { IonLabel, IonItem, IonAvatar, IonBadge } from "@ionic/react";
import { ReactComponent as AvatarImg } from "../../assets/avatar.svg";
import { Img } from "react-image";

var flatten = require("flat");

const VisitItem = (props) => {
  const { item } = props;

  const intl = useIntl();

  const color = item.overflow_months_number > 0 ? "danger" : "light";

  return (
    <IonItem
      key={item.id}
      detail={true}
      routerLink={`/app/visits/${item.patient.branch}/${item.patient.id}/${item.id}`}
    >
      <IonAvatar slot="start">
        {item.patient.avatar_url ? (
          <Img
            src={[item.patient.avatar_url]}
            unloader={<AvatarImg style={{ borderRadius: "50%" }} />}
          />
        ) : (
          <AvatarImg style={{ borderRadius: "50%" }} />
        )}
      </IonAvatar>
      <div style={{ padding: "6px 0" }}>
        <IonLabel>
          {getFullName(item.patient.surename, item.patient.first_name)}
        </IonLabel>
        <IonLabel color="medium">
          {getAddress(flatten(item.patient, { safe: true }))}
        </IonLabel>
        <IonBadge color={color} slot="end">
          {item.first_visit
            ? intl.formatMessage({
                id: "app.mobile.first_visit",
              })
            : item.months_since_last_visit
            ? `${item.months_since_last_visit} ${intl.formatMessage({
                id: "app.mobile.months_from_last_visit",
              })}`
            : ``}
        </IonBadge>
      </div>
      {(item.approved || item.verified) && (
        <IonBadge color={item.verified ? "primary" : "success"} slot="end">
          {intl.formatMessage({
            id: item.verified
              ? "app.mobile.table.verified"
              : "app.mobile.table.approved",
          })}
        </IonBadge>
      )}
    </IonItem>
  );
};

export default VisitItem;

// <List.Item
//   key={item.id}
//   prefix={
//     <AvatarComponent record={item.patient} text={item.patient.avatar_url} />
//   }
//   description={<Address record={flatten(item.patient, { safe: true })} />}
//   extra={
//     item.approved && (
//       <Tag color="success">
//         {intl.formatMessage({
//           id: "app.mobile.table.verified",
//         })}
//       </Tag>
//     )
//   }
//   clickable
// >
//   {getFullName(item.patient.surename, item.patient.first_name)}
// </List.Item>
